import { render, staticRenderFns } from "./typewriting.vue?vue&type=template&id=066047d6&scoped=true&"
import script from "./typewriting.vue?vue&type=script&lang=ts&"
export * from "./typewriting.vue?vue&type=script&lang=ts&"
import style0 from "./typewriting.vue?vue&type=style&index=0&id=066047d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066047d6",
  null
  
)

export default component.exports